import { render, staticRenderFns } from "./SaleDemandList.vue?vue&type=template&id=76441003&scoped=true"
import script from "./SaleDemandList.vue?vue&type=script&lang=js"
export * from "./SaleDemandList.vue?vue&type=script&lang=js"
import style0 from "./SaleDemandList.vue?vue&type=style&index=0&id=76441003&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76441003",
  null
  
)

export default component.exports